
export const rewardArrays = [
  // 第 1 组
  [
    { giftId: 'E560', giftName: '一百万个人土兵', sendNum: 5 },
    { giftId: 'MI10', giftName: '一百万个人兵粮', sendNum: 5 },
    { giftId: 'G610', giftName: '10绑币', sendNum: 1000 },
    { giftId: 'Y552', giftName: '限时称号*神鸡妙算', sendNum: 2 }
  ],

  // 第 2 组
  [
    { giftId: 'E560', giftName: '一百万个人土兵', sendNum: 4 },
    { giftId: 'MI10', giftName: '一百万个人兵粮', sendNum: 4 },
    { giftId: 'G610', giftName: '10绑币', sendNum: 800 },
    { giftId: 'Y552', giftName: '限时称号*神鸡妙算', sendNum: 2 }
  ],

  // 第 3 组
  [
    { giftId: 'E560', giftName: '一百万个人土兵', sendNum: 3 },
    { giftId: 'MI10', giftName: '一百万个人兵粮', sendNum: 3 },
    { giftId: 'G610', giftName: '10绑币', sendNum: 600 },
    { giftId: 'Y552', giftName: '限时称号*神鸡妙算', sendNum: 1 }
  ],

  // 第 4 组
  [
    { giftId: 'E560', giftName: '一百万个人土兵', sendNum: 2 },
    { giftId: 'MI10', giftName: '一百万个人兵粮', sendNum: 2 },
    { giftId: 'G610', giftName: '10绑币', sendNum: 400 },
    { giftId: 'Y552', giftName: '限时称号*神鸡妙算', sendNum: 1 }
  ],

  // 第 5 组
  [
    { giftId: 'E560', giftName: '一百万个人土兵', sendNum: 1 },
    { giftId: 'MI10', giftName: '一百万个人兵粮', sendNum: 1 },
    { giftId: 'G610', giftName: '10绑币', sendNum: 200 },
    { giftId: 'Y552', giftName: '限时称号*神鸡妙算', sendNum: 1 }
  ]
];

export default rewardArrays;
